import React from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Paper from 'components/Paper'
import ballIconUrl from 'stories/assets/intro_football.svg'
import AnimatedCircle from 'components/AnimatedCircle'

const stories = storiesOf('AnimatedCircle', module)

const styles: React.CSSProperties = {
  padding: 25,
  textAlign: 'center',
}

stories
  .add('AnimatedCircle', () => {
    return (
      <Paper color="accent">
        <Grid container justify="center">
          <Grid item md={4} lg={2} style={styles}>
            <AnimatedCircle />
            <Typography variant="body2" color="inherit">default</Typography>
          </Grid>
          <Grid item md={4} lg={2} style={styles}>
            <AnimatedCircle iconUrl={ballIconUrl} iconOpacity={0.5} />
            <Typography variant="body2" color="inherit">iconOpacity = 0.5</Typography>
          </Grid>
          <Grid item md={4} lg={2} style={styles}>
            <AnimatedCircle iconUrl={ballIconUrl} duration={5000} />
            <Typography variant="body2" color="inherit">duration = 5s</Typography>
          </Grid>
          <Grid item md={4} lg={2} style={styles}>
            <AnimatedCircle iconUrl={ballIconUrl} primaryColor="#ffccff" secondaryColor="#cc00cc" />
            <Typography variant="body2" color="inherit">
              primaryColor = #ffccff<br />secondaryColor = #cc00cc
            </Typography>
          </Grid>
          <Grid item md={4} lg={2} style={styles}>
            <AnimatedCircle checkmark />
            <Typography variant="body2" color="inherit">checkmark = true</Typography>
          </Grid>
          <Grid item md={4} lg={2} style={styles}>
            <AnimatedCircle checkmark primaryColor="#cc0000" secondaryColor="#ffcc00" />
            <Typography variant="body2" color="inherit">
            checkmark = true<br />primaryColor = #cc0000<br />secondaryColor = #ffcc00
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    )
  })
